export const LogTypeUM = {
  ACCOUNT: 'ACCOUNT',
  ACCOUNTGROUP: 'ACCOUNTGROUP',
  BANK: 'BANK',
  ORDER: 'ORDER',
  OWNER: 'OWNER',
  SETTINGS: 'SETTINGS',
  SIGNOFFRULE: 'SIGNOFFRULE',
  TEMPLATE: 'TEMPLATE',
  TRANSACTION: 'TRANSACTION',
  TRANSACTIONGROUP: 'TRANSACTIONGROUP',
  TRANSACTION_STATEMENTS: 'TRANSACTION_STATEMENTS',
  USER: 'USER',
  USERGROUP: 'USERGROUP',
  ACCOUNT_STATEMENTS: 'ACCOUNT_STATEMENTS',
  ACCOUNTGROUP_STATEMENTS: 'ACCOUNTGROUP_STATEMENTS',
  USER_DEFINED_REPORT: 'USER_DEFINED_REPORT',
  GENERAL_NOTIFICATION: 'GENERAL_NOTIFICATION',
  PAYMENT_VIEW_UPLOADED: 'PAYMENT_VIEW_UPLOADED',
  TWOMANRULE: 'TWOMANRULE',
  CLIENTLOG: 'CLIENTLOG',
} as const;

export const LogTypeCPS = {
  CASHPOOL: 'CASHPOOL',
  PARTICIPANTACCOUNT: 'PARTICIPANTACCOUNT',
  INTERCOMPANYRATE: 'INTERCOMPANYRATE',
  QUARTZSCHEDULERMETADATA: 'QUARTZSCHEDULERMETADATA',
} as const;

export const LogType = {
  ...LogTypeUM,
  ...LogTypeCPS,
} as const;

export type LogTypeType = (typeof LogType)[keyof typeof LogType];
export type LogTypeUMType = (typeof LogTypeUM)[keyof typeof LogTypeUM];

export enum LogTypeModel {
  ACCOUNT = 'ch.fides.eftweb.data.model.ClientAccount',
  ACCOUNTGROUP = 'ch.fides.portal.entity.AccountGroup',
  ACCOUNTGROUP_EFT = 'ch.fides.eftweb.data.model.AccountGroup',
  BANK = 'ch.fides.eftweb.data.model.ClientBank',
  OWNER = 'ch.fides.eftweb.data.model.ClientParty',
  SIGNOFFRULE = 'ch.fides.eftweb.data.model.SignatureRule',
  TEMPLATE = 'ch.fides.eftweb.data.model.PaymentTransactionTemplate',
  USER_EFT = 'ch.fides.eftweb.data.model.User',
  USERGROUP_EFT = 'ch.fides.eftweb.data.model.UserGroup',
  USER = 'ch.fides.portal.entity.User',
  USERGROUP = 'ch.fides.portal.entity.UserGroup',
  CLIENT_ACCOUNT = 'ch.fides.portal.entity.ClientAccount',
  BANK_CPS = 'ch.fides.cpsweb.model.Bank',
}
